export function formatLastActivity(lastActivity) {
  if (!lastActivity) return 'Sin actividad'
  const diffTime = Math.abs(Date.now() - new Date(lastActivity).getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  if (diffDays === 1) return 'Hace 1 día'
  if (diffDays < 7) return `Hace ${diffDays} días`
  if (diffDays < 30) return `Hace ${Math.ceil(diffDays / 7)} semanas`
  return `Hace ${Math.ceil(diffDays / 30)} meses`
}

/** Colores de status suaves (pergamino), no material brights. */
export function getRecentActivityColor(activity) {
  switch (activity) {
    case 'Activo':
      return '#5a7a5a'
    case 'Moderado':
      return '#9a7a40'
    case 'Inactivo':
      return '#8a5a48'
    default:
      return '#84776b'
  }
}

export function getTerritoryStatusColor(status) {
  switch (status) {
    case 'Paz':
      return '#5a7a5a'
    case 'Guerra':
      return '#9f5534'
    case 'Conflicto Interno':
      return '#a06040'
    case 'Tensión':
      return '#9a7a40'
    case 'Alianza':
      return '#5a6a7a'
    case 'Neutral':
      return '#84776b'
    default:
      return '#84776b'
  }
}

/** Kanji por slug/nombre — sentido del Han o traducción del topónimo. */
const TERRITORY_KANJI = {
  ame: '雨',
  an: '闇',
  fuego: '火',
  hana: '花',
  hayashi: '林',
  ishi: '石',
  kagi: '鍵',
  kawa: '川',
  kiba: '牙',
  kocha: '湖',
  kubi: '首',
  kuma: '熊',
  kusa: '草',
  kusuri: '薬',
  menrui: '麺',
  mitsu: '蜜',
  mori: '森',
  nami: '波',
  numa: '沼',
  oni: '鬼',
  redaku: '書',
  sawa: '沢',
  shijima: '静',
  shimo: '霜',
  sora: '空',
  sosen: '祖',
  suna: '砂',
  taki: '滝',
  tanbo: '田',
  tanima: '谷',
  tetsu: '鉄',
  tori: '鳥',
  tsuchi: '土',
  tsuki: '月',
  tsume: '爪',
  umi: '海',
  uzu: '渦',
  yama: '山',
  yasai: '菜',
  yuki: '雪',
}

export function getTerritoryKanji(territory) {
  const slug = String(territory?.slug || '')
    .trim()
    .toLowerCase()
  if (slug && TERRITORY_KANJI[slug]) return TERRITORY_KANJI[slug]

  const nameKey = String(territory?.name || '')
    .trim()
    .toLowerCase()
  if (nameKey && TERRITORY_KANJI[nameKey]) return TERRITORY_KANJI[nameKey]

  return '地'
}

export function getTopTerritories(territories, limit = 3) {
  const list = [...(territories || [])]
  const maxCombats = list.reduce((max, t) => Math.max(max, Number(t.combatCount || 0)), 0)

  if (maxCombats > 0) {
    return list
      .sort((a, b) => {
        const combatDiff = Number(b.combatCount || 0) - Number(a.combatCount || 0)
        if (combatDiff !== 0) return combatDiff
        return new Date(b.lastActivity || 0) - new Date(a.lastActivity || 0)
      })
      .slice(0, limit)
  }

  return list
    .sort((a, b) => new Date(b.lastActivity || 0) - new Date(a.lastActivity || 0))
    .slice(0, limit)
}

/** Etiqueta visible de un Han a partir del slug (`mori` → `Mori`). */
export function formatHanLabel(slug) {
  if (!slug) return ''
  const s = String(slug)
  return s.charAt(0).toUpperCase() + s.slice(1)
}
